/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AtualizarApresentacaoDto,
  AtualizarFarmacoDto,
  CatalogoFarmacoDetalheResponse,
  CatalogoFarmacosControllerListarParams,
  ClassesTerapeuticasResponse,
  CriarApresentacaoDto,
  CriarFarmacoDto,
  ErroResponse,
  FundirFarmacoDto,
  PaginaDeCatalogoFarmacosResponse,
  SugestoesDeFarmacosResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getCatalogoFarmacosControllerListarUrl = (params?: CatalogoFarmacosControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/catalogo-farmacos?${stringifiedParams}` : `/v1/admin/catalogo-farmacos`
}

/**
 * @summary Lista o catálogo, paginado. A busca atravessa princípio ativo, sinônimos e nome comercial — digitar "Vetoryl" acha "Trilostano".
 */
export const catalogoFarmacosControllerListar = async (params?: CatalogoFarmacosControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeCatalogoFarmacosResponse> => {

  return httpClient<PaginaDeCatalogoFarmacosResponse>(getCatalogoFarmacosControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCatalogoFarmacosControllerListarQueryKey = (params?: CatalogoFarmacosControllerListarParams,) => {
    return [
    `/v1/admin/catalogo-farmacos`, ...(params ? [params] : [])
    ] as const;
    }


export const getCatalogoFarmacosControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof catalogoFarmacosControllerListar>>, TError = ErroResponse>(params?: CatalogoFarmacosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogoFarmacosControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogoFarmacosControllerListar>>> = ({ signal }) => catalogoFarmacosControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogoFarmacosControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof catalogoFarmacosControllerListar>>>
export type CatalogoFarmacosControllerListarQueryError = ErroResponse


export function useCatalogoFarmacosControllerListar<TData = Awaited<ReturnType<typeof catalogoFarmacosControllerListar>>, TError = ErroResponse>(
 params: undefined |  CatalogoFarmacosControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoFarmacosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof catalogoFarmacosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoFarmacosControllerListar<TData = Awaited<ReturnType<typeof catalogoFarmacosControllerListar>>, TError = ErroResponse>(
 params?: CatalogoFarmacosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoFarmacosControllerListar>>,
          TError,
          Awaited<ReturnType<typeof catalogoFarmacosControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoFarmacosControllerListar<TData = Awaited<ReturnType<typeof catalogoFarmacosControllerListar>>, TError = ErroResponse>(
 params?: CatalogoFarmacosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista o catálogo, paginado. A busca atravessa princípio ativo, sinônimos e nome comercial — digitar "Vetoryl" acha "Trilostano".
 */

export function useCatalogoFarmacosControllerListar<TData = Awaited<ReturnType<typeof catalogoFarmacosControllerListar>>, TError = ErroResponse>(
 params?: CatalogoFarmacosControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogoFarmacosControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCatalogoFarmacosControllerCriarUrl = () => {




  return `/v1/admin/catalogo-farmacos`
}

/**
 * @summary Cria um princípio ativo no catálogo. O nome é o PRINCÍPIO ATIVO ("Trilostano"), não a marca — é ele que tem dose comparável entre pacientes.
 */
export const catalogoFarmacosControllerCriar = async (criarFarmacoDto: CriarFarmacoDto, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoFarmacoDetalheResponse> => {

  return httpClient<CatalogoFarmacoDetalheResponse>(getCatalogoFarmacosControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarFarmacoDto)
  }
);}





export const getCatalogoFarmacosControllerCriarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerCriar>>, TError,{data: CriarFarmacoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerCriar>>, TError,{data: CriarFarmacoDto}, TContext> => {

const mutationKey = ['catalogoFarmacosControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoFarmacosControllerCriar>>, {data: CriarFarmacoDto}> = (props) => {
          const {data} = props ?? {};

          return  catalogoFarmacosControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoFarmacosControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoFarmacosControllerCriar>>>
    export type CatalogoFarmacosControllerCriarMutationBody = CriarFarmacoDto
    export type CatalogoFarmacosControllerCriarMutationError = ErroResponse

    /**
 * @summary Cria um princípio ativo no catálogo. O nome é o PRINCÍPIO ATIVO ("Trilostano"), não a marca — é ele que tem dose comparável entre pacientes.
 */
export const useCatalogoFarmacosControllerCriar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerCriar>>, TError,{data: CriarFarmacoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoFarmacosControllerCriar>>,
        TError,
        {data: CriarFarmacoDto},
        TContext
      > => {
      return useMutation(getCatalogoFarmacosControllerCriarMutationOptions(options), queryClient);
    }
    export const getCatalogoFarmacosControllerClassesTerapeuticasUrl = () => {




  return `/v1/admin/catalogo-farmacos/classes-terapeuticas`
}

/**
 * @summary Classes terapêuticas já em uso, para alimentar o filtro da tela
 */
export const catalogoFarmacosControllerClassesTerapeuticas = async ( options?: Parameters<typeof httpClient>[1]): Promise<ClassesTerapeuticasResponse> => {

  return httpClient<ClassesTerapeuticasResponse>(getCatalogoFarmacosControllerClassesTerapeuticasUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCatalogoFarmacosControllerClassesTerapeuticasQueryKey = () => {
    return [
    `/v1/admin/catalogo-farmacos/classes-terapeuticas`
    ] as const;
    }


export const getCatalogoFarmacosControllerClassesTerapeuticasQueryOptions = <TData = Awaited<ReturnType<typeof catalogoFarmacosControllerClassesTerapeuticas>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerClassesTerapeuticas>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogoFarmacosControllerClassesTerapeuticasQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogoFarmacosControllerClassesTerapeuticas>>> = ({ signal }) => catalogoFarmacosControllerClassesTerapeuticas({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerClassesTerapeuticas>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogoFarmacosControllerClassesTerapeuticasQueryResult = NonNullable<Awaited<ReturnType<typeof catalogoFarmacosControllerClassesTerapeuticas>>>
export type CatalogoFarmacosControllerClassesTerapeuticasQueryError = unknown


export function useCatalogoFarmacosControllerClassesTerapeuticas<TData = Awaited<ReturnType<typeof catalogoFarmacosControllerClassesTerapeuticas>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerClassesTerapeuticas>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoFarmacosControllerClassesTerapeuticas>>,
          TError,
          Awaited<ReturnType<typeof catalogoFarmacosControllerClassesTerapeuticas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoFarmacosControllerClassesTerapeuticas<TData = Awaited<ReturnType<typeof catalogoFarmacosControllerClassesTerapeuticas>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerClassesTerapeuticas>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoFarmacosControllerClassesTerapeuticas>>,
          TError,
          Awaited<ReturnType<typeof catalogoFarmacosControllerClassesTerapeuticas>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoFarmacosControllerClassesTerapeuticas<TData = Awaited<ReturnType<typeof catalogoFarmacosControllerClassesTerapeuticas>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerClassesTerapeuticas>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Classes terapêuticas já em uso, para alimentar o filtro da tela
 */

export function useCatalogoFarmacosControllerClassesTerapeuticas<TData = Awaited<ReturnType<typeof catalogoFarmacosControllerClassesTerapeuticas>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerClassesTerapeuticas>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogoFarmacosControllerClassesTerapeuticasQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCatalogoFarmacosControllerSugestoesUrl = () => {




  return `/v1/admin/catalogo-farmacos/sugestoes`
}

/**
 * @summary A fila de curadoria: os fármacos criados por CLÍNICOS ao montar tratamento, ordenados pelos MAIS USADOS. Resolva fundindo em outro item, ou promovendo `origem` a CURADORIA.
 */
export const catalogoFarmacosControllerSugestoes = async ( options?: Parameters<typeof httpClient>[1]): Promise<SugestoesDeFarmacosResponse> => {

  return httpClient<SugestoesDeFarmacosResponse>(getCatalogoFarmacosControllerSugestoesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCatalogoFarmacosControllerSugestoesQueryKey = () => {
    return [
    `/v1/admin/catalogo-farmacos/sugestoes`
    ] as const;
    }


export const getCatalogoFarmacosControllerSugestoesQueryOptions = <TData = Awaited<ReturnType<typeof catalogoFarmacosControllerSugestoes>>, TError = ErroResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerSugestoes>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogoFarmacosControllerSugestoesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogoFarmacosControllerSugestoes>>> = ({ signal }) => catalogoFarmacosControllerSugestoes({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerSugestoes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogoFarmacosControllerSugestoesQueryResult = NonNullable<Awaited<ReturnType<typeof catalogoFarmacosControllerSugestoes>>>
export type CatalogoFarmacosControllerSugestoesQueryError = ErroResponse


export function useCatalogoFarmacosControllerSugestoes<TData = Awaited<ReturnType<typeof catalogoFarmacosControllerSugestoes>>, TError = ErroResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerSugestoes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoFarmacosControllerSugestoes>>,
          TError,
          Awaited<ReturnType<typeof catalogoFarmacosControllerSugestoes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoFarmacosControllerSugestoes<TData = Awaited<ReturnType<typeof catalogoFarmacosControllerSugestoes>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerSugestoes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoFarmacosControllerSugestoes>>,
          TError,
          Awaited<ReturnType<typeof catalogoFarmacosControllerSugestoes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoFarmacosControllerSugestoes<TData = Awaited<ReturnType<typeof catalogoFarmacosControllerSugestoes>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerSugestoes>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary A fila de curadoria: os fármacos criados por CLÍNICOS ao montar tratamento, ordenados pelos MAIS USADOS. Resolva fundindo em outro item, ou promovendo `origem` a CURADORIA.
 */

export function useCatalogoFarmacosControllerSugestoes<TData = Awaited<ReturnType<typeof catalogoFarmacosControllerSugestoes>>, TError = ErroResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerSugestoes>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogoFarmacosControllerSugestoesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCatalogoFarmacosControllerObterUrl = (id: string,) => {




  return `/v1/admin/catalogo-farmacos/${id}`
}

/**
 * @summary Detalha o fármaco com as apresentações comerciais
 */
export const catalogoFarmacosControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoFarmacoDetalheResponse> => {

  return httpClient<CatalogoFarmacoDetalheResponse>(getCatalogoFarmacosControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getCatalogoFarmacosControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/admin/catalogo-farmacos/${id}`
    ] as const;
    }


export const getCatalogoFarmacosControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof catalogoFarmacosControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCatalogoFarmacosControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof catalogoFarmacosControllerObter>>> = ({ signal }) => catalogoFarmacosControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type CatalogoFarmacosControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof catalogoFarmacosControllerObter>>>
export type CatalogoFarmacosControllerObterQueryError = ErroResponse


export function useCatalogoFarmacosControllerObter<TData = Awaited<ReturnType<typeof catalogoFarmacosControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoFarmacosControllerObter>>,
          TError,
          Awaited<ReturnType<typeof catalogoFarmacosControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoFarmacosControllerObter<TData = Awaited<ReturnType<typeof catalogoFarmacosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof catalogoFarmacosControllerObter>>,
          TError,
          Awaited<ReturnType<typeof catalogoFarmacosControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useCatalogoFarmacosControllerObter<TData = Awaited<ReturnType<typeof catalogoFarmacosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha o fármaco com as apresentações comerciais
 */

export function useCatalogoFarmacosControllerObter<TData = Awaited<ReturnType<typeof catalogoFarmacosControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getCatalogoFarmacosControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCatalogoFarmacosControllerAtualizarUrl = (id: string,) => {




  return `/v1/admin/catalogo-farmacos/${id}`
}

/**
 * @summary Atualiza o fármaco. É por aqui que a sugestão do clínico vira item curado: complete sinônimos e classe e mande `origem: "CURADORIA"` — a linha sai da fila de sugestões.
 */
export const catalogoFarmacosControllerAtualizar = async (id: string,
    atualizarFarmacoDto: AtualizarFarmacoDto, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoFarmacoDetalheResponse> => {

  return httpClient<CatalogoFarmacoDetalheResponse>(getCatalogoFarmacosControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarFarmacoDto)
  }
);}





export const getCatalogoFarmacosControllerAtualizarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerAtualizar>>, TError,{id: string;data: AtualizarFarmacoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerAtualizar>>, TError,{id: string;data: AtualizarFarmacoDto}, TContext> => {

const mutationKey = ['catalogoFarmacosControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoFarmacosControllerAtualizar>>, {id: string;data: AtualizarFarmacoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  catalogoFarmacosControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoFarmacosControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoFarmacosControllerAtualizar>>>
    export type CatalogoFarmacosControllerAtualizarMutationBody = AtualizarFarmacoDto
    export type CatalogoFarmacosControllerAtualizarMutationError = ErroResponse

    /**
 * @summary Atualiza o fármaco. É por aqui que a sugestão do clínico vira item curado: complete sinônimos e classe e mande `origem: "CURADORIA"` — a linha sai da fila de sugestões.
 */
export const useCatalogoFarmacosControllerAtualizar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerAtualizar>>, TError,{id: string;data: AtualizarFarmacoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoFarmacosControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarFarmacoDto},
        TContext
      > => {
      return useMutation(getCatalogoFarmacosControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getCatalogoFarmacosControllerDesativarUrl = (id: string,) => {




  return `/v1/admin/catalogo-farmacos/${id}`
}

/**
 * @summary DESATIVA — não apaga. Há tratamentos apontando para cá, e o fármaco descontinuado continua sendo o que aquele animal tomou. Responde com o item já desativado.
 */
export const catalogoFarmacosControllerDesativar = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoFarmacoDetalheResponse> => {

  return httpClient<CatalogoFarmacoDetalheResponse>(getCatalogoFarmacosControllerDesativarUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getCatalogoFarmacosControllerDesativarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerDesativar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerDesativar>>, TError,{id: string}, TContext> => {

const mutationKey = ['catalogoFarmacosControllerDesativar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoFarmacosControllerDesativar>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  catalogoFarmacosControllerDesativar(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoFarmacosControllerDesativarMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoFarmacosControllerDesativar>>>

    export type CatalogoFarmacosControllerDesativarMutationError = ErroResponse

    /**
 * @summary DESATIVA — não apaga. Há tratamentos apontando para cá, e o fármaco descontinuado continua sendo o que aquele animal tomou. Responde com o item já desativado.
 */
export const useCatalogoFarmacosControllerDesativar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerDesativar>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoFarmacosControllerDesativar>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getCatalogoFarmacosControllerDesativarMutationOptions(options), queryClient);
    }
    export const getCatalogoFarmacosControllerCriarApresentacaoUrl = (id: string,) => {




  return `/v1/admin/catalogo-farmacos/${id}/apresentacoes`
}

/**
 * @summary Acrescenta uma apresentação comercial ("Vetoryl 30 mg"). Concentração precisa de valor E unidade, ou de nenhum dos dois — é ela que transforma "1 comprimido" em dose.
 */
export const catalogoFarmacosControllerCriarApresentacao = async (id: string,
    criarApresentacaoDto: CriarApresentacaoDto, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoFarmacoDetalheResponse> => {

  return httpClient<CatalogoFarmacoDetalheResponse>(getCatalogoFarmacosControllerCriarApresentacaoUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarApresentacaoDto)
  }
);}





export const getCatalogoFarmacosControllerCriarApresentacaoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerCriarApresentacao>>, TError,{id: string;data: CriarApresentacaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerCriarApresentacao>>, TError,{id: string;data: CriarApresentacaoDto}, TContext> => {

const mutationKey = ['catalogoFarmacosControllerCriarApresentacao'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoFarmacosControllerCriarApresentacao>>, {id: string;data: CriarApresentacaoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  catalogoFarmacosControllerCriarApresentacao(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoFarmacosControllerCriarApresentacaoMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoFarmacosControllerCriarApresentacao>>>
    export type CatalogoFarmacosControllerCriarApresentacaoMutationBody = CriarApresentacaoDto
    export type CatalogoFarmacosControllerCriarApresentacaoMutationError = ErroResponse

    /**
 * @summary Acrescenta uma apresentação comercial ("Vetoryl 30 mg"). Concentração precisa de valor E unidade, ou de nenhum dos dois — é ela que transforma "1 comprimido" em dose.
 */
export const useCatalogoFarmacosControllerCriarApresentacao = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerCriarApresentacao>>, TError,{id: string;data: CriarApresentacaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoFarmacosControllerCriarApresentacao>>,
        TError,
        {id: string;data: CriarApresentacaoDto},
        TContext
      > => {
      return useMutation(getCatalogoFarmacosControllerCriarApresentacaoMutationOptions(options), queryClient);
    }
    export const getCatalogoFarmacosControllerAtualizarApresentacaoUrl = (id: string,
    apresentacaoId: string,) => {




  return `/v1/admin/catalogo-farmacos/${id}/apresentacoes/${apresentacaoId}`
}

/**
 * @summary Atualiza a apresentação comercial
 */
export const catalogoFarmacosControllerAtualizarApresentacao = async (id: string,
    apresentacaoId: string,
    atualizarApresentacaoDto: AtualizarApresentacaoDto, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoFarmacoDetalheResponse> => {

  return httpClient<CatalogoFarmacoDetalheResponse>(getCatalogoFarmacosControllerAtualizarApresentacaoUrl(id,apresentacaoId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarApresentacaoDto)
  }
);}





export const getCatalogoFarmacosControllerAtualizarApresentacaoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerAtualizarApresentacao>>, TError,{id: string;apresentacaoId: string;data: AtualizarApresentacaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerAtualizarApresentacao>>, TError,{id: string;apresentacaoId: string;data: AtualizarApresentacaoDto}, TContext> => {

const mutationKey = ['catalogoFarmacosControllerAtualizarApresentacao'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoFarmacosControllerAtualizarApresentacao>>, {id: string;apresentacaoId: string;data: AtualizarApresentacaoDto}> = (props) => {
          const {id,apresentacaoId,data} = props ?? {};

          return  catalogoFarmacosControllerAtualizarApresentacao(id,apresentacaoId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoFarmacosControllerAtualizarApresentacaoMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoFarmacosControllerAtualizarApresentacao>>>
    export type CatalogoFarmacosControllerAtualizarApresentacaoMutationBody = AtualizarApresentacaoDto
    export type CatalogoFarmacosControllerAtualizarApresentacaoMutationError = ErroResponse

    /**
 * @summary Atualiza a apresentação comercial
 */
export const useCatalogoFarmacosControllerAtualizarApresentacao = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerAtualizarApresentacao>>, TError,{id: string;apresentacaoId: string;data: AtualizarApresentacaoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoFarmacosControllerAtualizarApresentacao>>,
        TError,
        {id: string;apresentacaoId: string;data: AtualizarApresentacaoDto},
        TContext
      > => {
      return useMutation(getCatalogoFarmacosControllerAtualizarApresentacaoMutationOptions(options), queryClient);
    }
    export const getCatalogoFarmacosControllerDesativarApresentacaoUrl = (id: string,
    apresentacaoId: string,) => {




  return `/v1/admin/catalogo-farmacos/${id}/apresentacoes/${apresentacaoId}`
}

/**
 * @summary DESATIVA a apresentação — não apaga. Há vigências de tratamento apontando para ela. Responde com o fármaco inteiro.
 */
export const catalogoFarmacosControllerDesativarApresentacao = async (id: string,
    apresentacaoId: string, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoFarmacoDetalheResponse> => {

  return httpClient<CatalogoFarmacoDetalheResponse>(getCatalogoFarmacosControllerDesativarApresentacaoUrl(id,apresentacaoId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getCatalogoFarmacosControllerDesativarApresentacaoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerDesativarApresentacao>>, TError,{id: string;apresentacaoId: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerDesativarApresentacao>>, TError,{id: string;apresentacaoId: string}, TContext> => {

const mutationKey = ['catalogoFarmacosControllerDesativarApresentacao'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoFarmacosControllerDesativarApresentacao>>, {id: string;apresentacaoId: string}> = (props) => {
          const {id,apresentacaoId} = props ?? {};

          return  catalogoFarmacosControllerDesativarApresentacao(id,apresentacaoId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoFarmacosControllerDesativarApresentacaoMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoFarmacosControllerDesativarApresentacao>>>

    export type CatalogoFarmacosControllerDesativarApresentacaoMutationError = ErroResponse

    /**
 * @summary DESATIVA a apresentação — não apaga. Há vigências de tratamento apontando para ela. Responde com o fármaco inteiro.
 */
export const useCatalogoFarmacosControllerDesativarApresentacao = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerDesativarApresentacao>>, TError,{id: string;apresentacaoId: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoFarmacosControllerDesativarApresentacao>>,
        TError,
        {id: string;apresentacaoId: string},
        TContext
      > => {
      return useMutation(getCatalogoFarmacosControllerDesativarApresentacaoMutationOptions(options), queryClient);
    }
    export const getCatalogoFarmacosControllerFundirUrl = (id: string,) => {




  return `/v1/admin/catalogo-farmacos/${id}/fundir`
}

/**
 * @summary Funde este fármaco em outro: aponta `substituidoPorId` e desativa. Os tratamentos já registrados continuam apontando para o item antigo — é a LEITURA que segue a seta, porque repontá-los reescreveria o que o clínico escolheu na época.
 */
export const catalogoFarmacosControllerFundir = async (id: string,
    fundirFarmacoDto: FundirFarmacoDto, options?: Parameters<typeof httpClient>[1]): Promise<CatalogoFarmacoDetalheResponse> => {

  return httpClient<CatalogoFarmacoDetalheResponse>(getCatalogoFarmacosControllerFundirUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(fundirFarmacoDto)
  }
);}





export const getCatalogoFarmacosControllerFundirMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerFundir>>, TError,{id: string;data: FundirFarmacoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerFundir>>, TError,{id: string;data: FundirFarmacoDto}, TContext> => {

const mutationKey = ['catalogoFarmacosControllerFundir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof catalogoFarmacosControllerFundir>>, {id: string;data: FundirFarmacoDto}> = (props) => {
          const {id,data} = props ?? {};

          return  catalogoFarmacosControllerFundir(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CatalogoFarmacosControllerFundirMutationResult = NonNullable<Awaited<ReturnType<typeof catalogoFarmacosControllerFundir>>>
    export type CatalogoFarmacosControllerFundirMutationBody = FundirFarmacoDto
    export type CatalogoFarmacosControllerFundirMutationError = ErroResponse

    /**
 * @summary Funde este fármaco em outro: aponta `substituidoPorId` e desativa. Os tratamentos já registrados continuam apontando para o item antigo — é a LEITURA que segue a seta, porque repontá-los reescreveria o que o clínico escolheu na época.
 */
export const useCatalogoFarmacosControllerFundir = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof catalogoFarmacosControllerFundir>>, TError,{id: string;data: FundirFarmacoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof catalogoFarmacosControllerFundir>>,
        TError,
        {id: string;data: FundirFarmacoDto},
        TContext
      > => {
      return useMutation(getCatalogoFarmacosControllerFundirMutationOptions(options), queryClient);
    }
